import Avatar from '@components/Avatar/Avatar';
import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { StyledContainer } from './BasicInfoHeader.styles';
import { BasicInfoHeaderProps } from './BasicInfoHeader.types';

const BasicInfoHeader = <
  T extends {
    avatar?: string;
    basicDetails: { firstName: string; lastName: string };
  }
>({
  user,
}: BasicInfoHeaderProps<T>) => {
  return (
    <StyledContainer>
      <Avatar user={{ ...user.basicDetails, avatar: user.avatar }} />
      <Flex ml={9} gap={5} flexDirection='column'>
        <Text
          variant='h4'
          fontWeight='fontWeightBold'
        >{`${user.basicDetails.firstName} ${user.basicDetails.lastName}`}</Text>
      </Flex>
    </StyledContainer>
  );
};

export default BasicInfoHeader;
